import { gql } from '@apollo/client'

import { AccountBalanceAreaChart } from 'pages/Dashboard/DashboardFinance/AccountBalanceChart/AccountBalanceAreaChart'

export const AccountBalanceChartQuery = gql`
  query AccountBalanceChartQuery($range: DateRange!, $timeZone: String!) {
    getDebitCardAccountBalances(range: $range, timeZone: $timeZone) {
      ...AccountBalanceAreaChartDebitCardAccountBalanceFragment
    }
  }

  ${AccountBalanceAreaChart.fragments.DebitCardAccountBalance}
`
